<!-- Revised on 2025/05/13 by mnavarro -->
<template>
  <tr>
    <th v-for="(item,index) of headers" :key="index" :class="getClasses(index)" @click="changedHeader(index)">
      <a data-sortable href="#" :class="{'dataTable-sorter': item.sort.sorteable}">{{ item.title }}</a>
    </th>
  </tr>
</template>

<script>

  export default {
    name: "GenericTableHeaderV2",
    props: {
      headers: {
        type: Array,
        default: () => [
          {
            title: "",
            column: "",
            sort: {
              sorteable: false,
              order: "desc"
            }
          }
        ]
      },
      listFilters: {
        type: Object,
        default: null,
      },
    },
    emits: ['changed-header'],
    data() {
      return {
        sort: {
          index: -1,
          header: "",
          order: "desc",
        },
        bar: this.headers,
      }
    },
    methods: {
      changedHeader(index) {
        if (!this.headers[index].sort.sorteable) {
          return;
        }
        let oldOrder= this.bar[index].sort.order;
        this.bar[index].sort.order = oldOrder == "desc" ? "asc" : "desc";
        if (this.sort.index!=-1 && index!= this.sort.index){
          this.bar[this.sort.index].sort.order="";
        }
        this.sort = {
          index:index,
          order: this.bar[index].sort.order,
          header:this.bar[index].title,
          column: this.bar[index].column,
        };
        this.$emit('changed-header', this.sort);

      },
      getClasses(index) {
        if(!this.bar[index].sort.sorteable){
          return;
        }
        return this.bar[index].sort.order;
      },
    }
  };

</script>
